// ------------------------------------------------------------
// - Core preferences - general across all projects
// ------------------------------------------------------------
export interface MwCorePreferenceApiModel {
  navSidebarFolded: boolean | null;
  customPreferences: { [key: string]: any };
}

export class MwCorePreferenceModel {
  navSidebarFolded: boolean | null = null;
  customPreferences = {};
  gridStates: { [id: string]: any[] } = {};

  constructor(data?: MwCorePreferenceApiModel) {
    Object.assign(this, data);

    this.navSidebarFolded =
      this.navSidebarFolded === undefined ? null : this.navSidebarFolded;
  }
}

// ------------------------------------------------------------
// - User preferences - unique for app
// ------------------------------------------------------------
export interface UserPreferenceViewModel {
  key: string;
  data: string;
}
